/* eslint-disable no-undef */
import { html, LitElement } from 'lit';

export class IconHome24 extends LitElement {
    render() {
        return html`<svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Home</title>
            <path
                d="M2.08566 10.5453L11.439 1.43968C11.5783 1.30029 11.7437 1.18971 11.9258 1.11427C12.1078 1.03883 12.3029 1 12.5 1C12.6971 1 12.8922 1.03883 13.0743 1.11427C13.2563 1.18971 13.4217 1.30029 13.561 1.43968L22.9144 10.5453"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M17 4.62866V3.12866H20.5V7.84375"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M3.5 9.5V18.069V21.6552C3.5 22.0118 3.6724 22.3539 3.97928 22.6061C4.28616 22.8583 4.70237 23 5.13636 23H19.8636C20.2976 23 20.7138 22.8583 21.0207 22.6061C21.3276 22.3539 21.5 22.0118 21.5 21.6552V9.5"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M15.5 23V18C15.5 16.3431 14.1569 15 12.5 15V15C10.8431 15 9.5 16.3431 9.5 18V23"
                stroke="currentColor"
                stroke-width="1.5"
            />
        </svg>`;
    }
}
if (!customElements.get('icon-home24')) {
    customElements.define('icon-home24', IconHome24);
}
